import { render, staticRenderFns } from "./DialogTemplate.vue?vue&type=template&id=1201efa8&scoped=true"
import script from "./DialogTemplate.vue?vue&type=script&lang=js"
export * from "./DialogTemplate.vue?vue&type=script&lang=js"
import style0 from "./DialogTemplate.vue?vue&type=style&index=0&id=1201efa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201efa8",
  null
  
)

export default component.exports